module.exports = __webpack_public_path__ + "static/media/rhino-peep@2x.71235d6e.png";